import React from "react";
import PropTypes from "prop-types";
import VertBarChart from "../VertBarChart";
import SimpleLegend from "../SimpleLegend";
import { BlurbTime } from "../Text";
import { COLORS } from "../../utils/constants";
import { formatPerc } from "../../utils/dataHelpers/formatters";

const JudgeTime = ({ selectedJudgeData, year }) => {
  const {
    totalDaysWithEvents,
    daysWithOnlyEventsBefore1Pm,
    totalDaysWithNoEvents,
    percDaysWithOnlyEventsBefore1Pm,
    lastName,
  } = selectedJudgeData;
  const chartData = [
    {
      year,
      daysWithOnlyEventsBefore1Pm,
      otherDaysWithCaseEvents:
        totalDaysWithEvents - daysWithOnlyEventsBefore1Pm,
      totalDaysWithNoEvents,
    },
  ];
  const stackCategories = [
    {
      accessor: "daysWithOnlyEventsBefore1Pm",
      label: "Days with no cases after 1 p.m.",
      fill: COLORS.chartPrimary,
    },
    {
      accessor: "otherDaysWithCaseEvents",
      label: "Other days with cases",
      fill: COLORS.chartSecondary,
    },
    {
      accessor: "totalDaysWithNoEvents",
      label: "Days with no cases",
      fill: COLORS.chartNoData,
      legendExclude: true,
    },
  ];
  const annotationLabel = [
    "No afternoon cases on",
    <tspan>
      <tspan className="panel__judge-text-emphasis">
        {formatPerc(percDaysWithOnlyEventsBefore1Pm * 100, 0)}
      </tspan>{" "}
      of{" "}
      <tspan className="panel__judge-text-emphasis">
        {totalDaysWithEvents}
      </tspan>{" "}
      days with case events
    </tspan>,
  ];
  const paidTimeOff = [0, daysWithOnlyEventsBefore1Pm];
  const annotationDefaultPos = "right";
  const tooltipComponent = (
    <BlurbTime
      lastName={lastName}
      daysWithOnlyEventsBefore1Pm={daysWithOnlyEventsBefore1Pm}
      totalDaysWithEvents={totalDaysWithEvents}
      year={year}
      percDaysWithOnlyEventsBefore1Pm={percDaysWithOnlyEventsBefore1Pm}
    />
  );

  return (
    <div className="panel__judge-day-container">
      <SimpleLegend legendItems={stackCategories} data={chartData[0]} />
      <div className="panel__judge-day-chart-container">
        <VertBarChart
          data={chartData}
          dataKey="year"
          dataYear={year}
          stackCategories={stackCategories}
          annotationLabel={annotationLabel}
          refAreaValue={daysWithOnlyEventsBefore1Pm}
          refAreaRange={paidTimeOff}
          annotationDefaultPos={annotationDefaultPos}
          tooltipPayload={tooltipComponent}
          disableDynamicPos
          hideRefArea
          hideRefLines
        />
      </div>
    </div>
  );
};

JudgeTime.propTypes = {
  selectedJudgeData: PropTypes.objectOf(PropTypes.any).isRequired,
  year: PropTypes.number.isRequired,
};

export default JudgeTime;
